// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-exchanges-api';

export const useGetExchanges: typeof hookExports.useGetExchanges = hookExports.useGetExchanges;
export const useLazyGetExchanges: typeof hookExports.useLazyGetExchanges =
  hookExports.useLazyGetExchanges;
